// handwritten-note.js

/**
 * Initialize Handwritten Note functionality
 * Works on main product page or inside Quick-Add modal
 * @param {HTMLElement} rootElement Optional root to search within. Defaults to document.
 */
function initHandwrittenNote(rootElement = document) {
  // Grab elements inside rootElement
  const noteFlag = rootElement.querySelector("#handwritten-note-flag");
  const addNoteButton = rootElement.querySelector("#add-note-button");
  const closeNoteButton = rootElement.querySelector("#close-note-flag");

  // Stop if required elements are missing
  if (!noteFlag || !addNoteButton || !closeNoteButton) return;

  // Create floating icon if missing
  let noteIconButton = document.getElementById("note-icon-button");
  if (!noteIconButton) {
    noteIconButton = document.createElement("button");
    noteIconButton.id = "note-icon-button";
    noteIconButton.innerHTML = `<img src="https://the-english-schoolhouse.myshopify.com/cdn/shop/files/Note-Icon.png" alt="Note" style="width: 75px; height: 75px;">`;
    Object.assign(noteIconButton.style, {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: "9999",
      border: "none",
      background: "transparent",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    });
    document.body.appendChild(noteIconButton);
  }

  // ------------------------
  // Show/hide functions
  // ------------------------
  const minimizeNote = () => {
    noteFlag.classList.add("minimized");
    noteIconButton.style.display = "flex";
    localStorage.setItem("noteMinimized", "true");
    sessionStorage.setItem("noteSeen", "true");
    stopWiggle();
  };

  const maximizeNote = () => {
    noteFlag.classList.remove("minimized");
    noteIconButton.style.display = "none";
    localStorage.setItem("noteMinimized", "false");
    sessionStorage.setItem("noteSeen", "true");
    stopWiggle();
  };

  // ------------------------
  // Wiggle animation
  // ------------------------
  const startWiggle = () => {
    noteIconButton.classList.add("wiggle-loop");
  };

  const stopWiggle = () => {
    noteIconButton.classList.remove("wiggle-loop");
  };

  // ------------------------
  // Event listeners
  // ------------------------
  closeNoteButton.addEventListener("click", minimizeNote);
  noteIconButton.addEventListener("click", maximizeNote);

  addNoteButton.addEventListener("click", () => {
    const noteMessage = rootElement.querySelector("#handwritten-note-message").value;
    if (!noteMessage) return alert("Please enter a message for the note.");

    const selectedVariantInput = rootElement.querySelector('[name="id"]');
    if (!selectedVariantInput || !selectedVariantInput.value) {
      return alert("Please select a product variant first.");
    }

    const variantId = parseInt(selectedVariantInput.value, 10);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { "Handwritten Note": noteMessage },
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add note");
        return res.json();
      })
      .then(() => {
        minimizeNote();
        window.location.reload(); // optional: replace with success message if preferred
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to add note. Please try again.");
      });
  });

  // ------------------------
  // Initial state
  // ------------------------
  if (localStorage.getItem("noteMinimized") === "true") {
    minimizeNote();
  } else {
    noteIconButton.style.display = "flex"; // default minimized
    noteFlag.classList.add("minimized");
  }

  // ------------------------
  // Auto behaviors
  // ------------------------
  const autoDelay = 3000; // 3s delay
  const noteSeen = sessionStorage.getItem("noteSeen");

  if (!noteSeen) {
    if (window.innerWidth <= 767) {
      // Mobile: auto pop open
      setTimeout(maximizeNote, autoDelay);
    } else {
      // Desktop: start gentle wiggle
      setTimeout(startWiggle, autoDelay);
    }
  }
}

// ------------------------
// Wiggle CSS (fixed)
// ------------------------
const style = document.createElement("style");
style.innerHTML = `
@keyframes gentleWiggle {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-5deg); }
  50% { transform: rotate(5deg); }
  75% { transform: rotate(-3deg); }
}

/* Apply animation to button and any img inside it */
#wrapper #note-icon-button.wiggle-loop,
#note-icon-button.wiggle-loop,
#note-icon-button.wiggle-loop img {
  animation: gentleWiggle 1s ease-in-out infinite;
}
`;
document.head.appendChild(style);

// ------------------------
// Run on page load
// ------------------------
document.addEventListener("DOMContentLoaded", () => {
  // Main product pages
  if (window.location.pathname.includes("/products/")) {
    initHandwrittenNote();
  }

  // Quick-Add modal integration
  document.addEventListener("modalOpened", (e) => {
    let modalContent = e.detail.modalContent;

    // Convert string to DOM node if needed
    if (typeof modalContent === "string") {
      const temp = document.createElement("div");
      temp.innerHTML = modalContent;
      modalContent = temp;
    }

    if (modalContent) {
      initHandwrittenNote(modalContent);
    }
  });
});